const geoSuccess = () => {
  // do nothing.
};

const geoError = (error: any) => {
  console.log('Error occurred. Error code: ' + error.code);

  // error.code can be:
  //   0: unknown error
  //   1: permission denied
  //   2: position unavailable (error response from location provider)
  //   3: timed out
  switch (error.code) {
    case error.PERMISSION_DENIED:
      console.error('User denied the request for Geolocation.');
      break;
    case error.POSITION_UNAVAILABLE:
      console.error('Location information is unavailable.');
      break;
    case error.TIMEOUT:
      console.error('The request to get user location timed out.');
      break;
    case error.UNKNOWN_ERROR:
      console.error('An unknown error occurred.');
      break;
    default:
      break;
  }
};

export const getGPSLocation = () => {
  const geoOptions = {
    timeout: 10 * 1000,
  };

  if (navigator.geolocation) {
    return navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);
  } else {
    console.log('Geo Location not supported by browser');
  }
};
